import Vue from 'vue'

/**
 * @author Jose Luis R
 * Use to reject files during LV process
 * @param payload Array of id
 * @return {Object}
 */

const rejectFiles = (payload) =>
  Vue.$http.put(`catalogs/common/file/reject/`, {
    pk: payload
  })
    .then((response) => response.data)
    .catch((err) => { throw err })

export default rejectFiles



// WEBPACK FOOTER //
// ./src/services/purchase/lifting/rejectFiles.js